module.exports = __webpack_public_path__ + "img/solution-msil-function-icon-5.b0273db8.svg";